export const calculateOffsetTop = (element: HTMLElement, id: string): number => {
  if (!element || element.id === id) {
    return 0;
  }
  const offsetTop = element.offsetTop;
  const offsetParent = element.offsetParent;

  return offsetTop + calculateOffsetTop(offsetParent as HTMLElement, id);
};

export const calculateOffsetLeft = (element: HTMLElement, id: string): number => {
  if (!element || element.id === id || !element) {
    return 0;
  }
  const offsetLeft = element.offsetLeft;
  const offsetParent = element.offsetParent;

  return offsetLeft + calculateOffsetLeft(offsetParent as HTMLElement, id);
};
